export default __webpack_public_path__ + "static/media/trekking.2f2f90a4.svg";